export default "__VITE_ASSET__CRAtYuG4__"